// extracted by mini-css-extract-plugin
export default {"unconfirmedDelivery":"DeliveryTable_unconfirmedDelivery__XNA9Q"};